import * as React from 'react'

import {
  Box,
} from '@mui/material'

function Help() {
  return (
    <Box className='w-full'>
      Help
    </Box>
  );
}

export default Help;